import { Injectable } from '@angular/core';
import { DatePipe } from '@angular/common';
import { AbstractControl, FormGroup } from '@angular/forms';
import { debounceTime, map, startWith } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';
import * as moment from 'moment';
import { MasterConstant } from '@app/constant/master.constant';
import { TableConstant } from '@app/constant/table.constant';

@Injectable({ providedIn: 'root' })
export class CommonHelper {

  constructor(private datePipe: DatePipe) { }

  public domainURL = `${window.location.origin}`;
  public onHvrTitleDesc = TableConstant.onHoverTitleDesc;
  public sincId = new BehaviorSubject<any>(1);
  public share = this.sincId.asObservable();
  public isSincCreate = new BehaviorSubject<boolean>(false);
  public isFailureClosed = new BehaviorSubject<boolean>(false);
  public shareIsSincCreate = this.isSincCreate.asObservable();

  public hazardRating = new BehaviorSubject<any>(null);
  public hazardRatingValue$ = this.hazardRating.asObservable();

  public reloadData = new BehaviorSubject<any>(null);
  public apireloadData$ = this.reloadData.asObservable();

  changeHeaderHeightURL(urlKey: string) {
    return MasterConstant.ChangeHeaderHeightURLs?.find(e => urlKey.includes(e.name)) ? true : false;
  }

  disableFooterURL(urlKey: string) {
    return MasterConstant.DisableFooterURLs?.find(e => urlKey.includes(e.name)) ? false : true;
  }

  getClassHazardRating(hazardRating: number) {
    var r1 = hazardRating >= 20 && hazardRating <= 49 ? 'amberlozenge' : 'redlozenge';
    var r2 = hazardRating >= 1 && hazardRating <= 19 ? 'greenlozenge' : r1;
    return hazardRating === 0 ? 'greylozenge' : r2;
  }

  showDots(message: string, len: number) {
    return (message?.length > len) ? message.substring(0, len) + '...' : message;
  }

  bindTempModel(failureId: number, failureCode: string, failureDate: string, status: string, failureDetails: string, riskCode: string, priority: any) {
    return {
      FailureCode: { 'Value': failureCode, 'IsHyperlink': true, RedirectionLink: `${this.domainURL}/failure/fmanagement/${failureId}`, openInNewTab: true },
      FailureDate: { 'Value': failureDate ? this.getformattedDateTime(failureDate, null, true) : '', 'IsHyperlink': false },
      Status: { 'Value': status, 'IsHyperlink': false },
      FailureDetails: { 'Value': this.showDots(failureDetails, 50), 'IsHyperlink': false },
      Risk: { 'Value': riskCode, 'IsHyperlink': false, 'title': riskCode + this.onHvrTitleDesc.Risk[riskCode] },
      Priority: { 'Value': priority?.toString(), 'IsHyperlink': false, 'title': priority + this.onHvrTitleDesc.Priority[priority?.toString()] },
    }
  }

  getCurrentDateTime() {
    return this.datePipe.transform(new Date(), 'yyyy-MM-ddTHH:mm:ss');
  }
  getCurrentTime() {
    let now = new Date();
    return ('0' + now.getHours()).slice(-2) + ':' + ('0' + now.getMinutes()).slice(-2);
  }
  getformattedDateTime(dteValue: any, dteformat: string, dteTme: boolean = false, noHrs: boolean = true, key: string = ' ') {
    var hrs = noHrs ? '' : ' hrs';
    if (dteValue === null) {
      return '-';

    } else {
      let dte = moment(dteValue).format(dteformat === null ? 'DD/MM/YYYY' : dteformat);
      let tme = dteTme ? moment(dteValue).format('HH:mm') + hrs : '';
      return (dte + key + tme);
    }
  }
  setformattedDateTime(dteValue: any, sysTme: boolean = true, tmeValue: any = null) {
    let dte = this.datePipe.transform(dteValue, 'yyyy-MM-dd');
    let tme = sysTme ? this.datePipe.transform(new Date(), 'HH:mm:ss') : tmeValue;
    return this.datePipe.transform((dte + 'T' + tme), 'yyyy-MM-ddTHH:mm:ss');
  }

  setDateTime(dte: any, tme: any) {
    let dtTime = this.datePipe.transform(dte, 'yyyy-MM-dd') + 'T' + (tme ? tme : this.datePipe.transform(new Date(), 'HH:mm:ss.SSS'));
    return this.datePipe.transform(dtTime, 'yyyy-MM-ddTHH:mm:ss.SSS');
  }
  setDate(value: any, format: string = '') {
    var res;
    if (value) {
      if (format === 'ddmmyyyy') { res = moment(value).format('DD/MM/YYYY'); }
      else if (format === 'MMM dd yyyy') { res = moment(value).format('MMM DD YYYY'); }
      else { res = moment(value).format('DD MMMM YYYY'); }
      return res;
    }

  }
  setTime(value: any, showHrs: boolean = false) {
    if (value) { return moment(value).format('HH:mm') + (showHrs ? '' : ' hrs') }
  }

  isNullOrUndefined(value: any): boolean {
    return value !== undefined && value !== null && value !== '';
  }
  isNumber(value: string | number): boolean {
    return (value != null && value !== '' && !isNaN(Number(value.toString())));
  }

  requireMatch(control: AbstractControl) {
    return control.value && typeof control.value === 'string' ? { 'incorrect': true } : null;
  }
  requireMatchFreeText(control: AbstractControl) {
    return null;
  }
  whitespaceValidator(control: AbstractControl) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true }
  }

  getFaultTitle(fromVal: string = '', toVal: string = '') {
    var fval;
    if (fromVal === '') { fval = ''; }
    else { fval = ('*' + fromVal + '* at ' + (toVal ? '*' + toVal + '*' : '')); }

    return fval;
  }
  getMasterId(model: any[]) {
    return model?.length > 0 ? model[0].masterId : null;
  }
  getModelValues(model: any[], idVal: any, key: string) {
    let id = key === 'SignalBoxName' ? idVal : Number(idVal);
    return model ? getFindModel(model, key, id) : null;
  }
  filterValueChanges(formcontrol: AbstractControl, model: any[], key: string, len: number = 3, filtername: string = null) {
    var result = [];
    if (filtername != 'blank') { result = model; }

    return formcontrol.valueChanges
      .pipe(
        startWith(''),
        debounceTime(400),
        map((val: any[]) => {
          if (val && val.length >= len) { return getFilterModel(model, key, val.toString().toLowerCase()); }
          else { return result; }
        }));
  }

  getFormControlValue(formcontrol: AbstractControl) {
    return this.isNullOrUndefined(formcontrol.value) ? formcontrol.value : null;
  }
  public getFormControlName(control: AbstractControl): string | null {
    var group = <FormGroup>control.parent;
    if (!group) { return null; }
    let name: string;
    Object.keys(group.controls).forEach(key => {
      let childControl = group.get(key);
      if (childControl !== control) { return; }
      name = key;
    });
    return name;
  }

  measure_converter(input_measure: any, input_unit: any, output_unit: any = 'Yards') {
    let measure_output;
    let yards: any;
    let metres: any;
    let negative_sign = (input_measure < 0);

    if (negative_sign) input_measure = Math.abs(input_measure);

    if (input_unit === 'Miles.Yards') {
      yards = Math.round((Math.trunc(input_measure) * 1760) + ((input_measure - Math.trunc(input_measure)) * 10000));
    } else if (input_unit === 'Miles.Chains') {
      yards = ((Math.trunc(input_measure)) * 1760) + (((input_measure - (Math.trunc(input_measure))) * 100) * 22);
    } else if (input_unit === 'Kilometers.Metres') {
      yards = Math.round(((input_measure) * 1000) / 0.9144);
    } else if (input_unit === 'Yards') {
      yards = input_measure;
    } else if (input_unit === 'Chains') {
      yards = input_measure * 22;
    } else if (input_unit === 'Metres') {
      yards = input_measure / 0.9144;
    }

    if (output_unit === 'Metres') {
      metres = yards * 0.9144;
      measure_output = Math.round(metres);

    } else if (output_unit === 'Kilometers.Metres') {
      metres = yards * 0.9144;
      measure_output = (Math.trunc(metres / 1000) + ((metres % 1000) / 1000)).toFixed(3);
      measure_output = measure_output.split('.')[0].padStart(3, '0') + '.' + measure_output.split('.')[1].padStart(3, '0');

    } else if (output_unit === 'Miles.Yards') {
      measure_output = (Math.trunc(yards / 1760) + (yards % 1760) / 10000).toFixed(4);
      measure_output = measure_output.split('.')[0].padStart(3, '0') + '.' + measure_output.split('.')[1].padStart(4, '0');

    } else if (output_unit === 'Miles.Chains') {
      measure_output = (Math.trunc(yards / 1760) + (((yards % 1760) / 22) / 100)).toFixed(2);
      measure_output = measure_output.split('.')[0].padStart(3, '0') + '.' + measure_output.split('.')[1].padStart(2, '0');

    } else if (output_unit === 'Yards') {
      measure_output = Math.round(yards);
    }

    if (negative_sign) measure_output = measure_output * -1;
    return measure_output;
  }

  measure_converter_new(input_measure: any, input_unit: any, output_unit: any = 'Yards'): { display: string; value: string } {
    let measure_output: any;
    let actualValue: any;
    let yards: any;
    let metres: any;
    let negative_sign = (input_measure < 0);

    if (negative_sign) input_measure = Math.abs(input_measure).toString();

    if (input_unit === 'Miles.Yards') {
      let mileageNumberValue = this.mileageToNumber(input_measure);
      if (mileageNumberValue.decimalPart === 1760) { mileageNumberValue.intPart += 1; mileageNumberValue.decimalPart = 0; }
      let _value: any = mileageNumberValue.intPart + '.' + mileageNumberValue.decimalPart;
      yards = Math.round((Math.trunc(_value) * 1760) + ((_value - Math.trunc(_value)) * this.getMultiplier(mileageNumberValue.decimalPart)));

    } else if (input_unit === 'Miles.Chains') {
      let mileageNumberValue = this.mileageToNumber(input_measure);
      if (mileageNumberValue.decimalPart === 80) { mileageNumberValue.intPart += 1; mileageNumberValue.decimalPart = 0; }
      let _value: any = mileageNumberValue.intPart + '.' + mileageNumberValue.decimalPart;
      yards = Math.round(((Math.trunc(_value)) * 1760) + (((_value - (Math.trunc(_value))) * this.getMultiplier(mileageNumberValue.decimalPart)) * 22));

    } else if (input_unit === 'Kilometers.Metres') {
      let mileageNumberValue = this.mileageToNumber(input_measure);
      yards = Math.round(((mileageNumberValue.intPart * 1000) + (mileageNumberValue.decimalPart)) / 0.9144);

    } else if (input_unit === 'Yards') {
      yards = input_measure;

    } else if (input_unit === 'Chains') {
      yards = input_measure * 22;

    } else if (input_unit === 'Metres') {
      yards = input_measure / 0.9144;
    }

    if (output_unit === 'Metres') {
      metres = yards * 0.9144;
      actualValue = metres;
      measure_output = Math.round(metres);

    } else if (output_unit === 'Kilometers.Metres') {
      metres = yards * 0.9144;
      actualValue = (Math.trunc(metres / 1000) + ((metres % 1000) / 1000)).toString();
      measure_output = (Math.trunc(metres / 1000) + ((metres % 1000) / 1000)).toFixed(3);
      measure_output = measure_output.split('.')[0].padStart(3, '0') + '.' + measure_output.split('.')[1].padStart(3, '0');
      if (actualValue.length > 7) actualValue = actualValue.split('.')[0].padStart(3, '0') + '.' + actualValue.split('.')[1].padStart(3, '0').substring(0, 3);

    } else if (output_unit === 'Miles.Yards') {
      let miles = Math.trunc(yards / 1760);
      let _yards = (yards - (miles * 1760));
      measure_output = miles.toString().padStart(3, '0') + '.' + _yards.toString().padStart(4, '0');
      actualValue = miles + '.' + _yards;

    } else if (output_unit === 'Miles.Chains') {
      actualValue = (Math.trunc(yards / 1760) + (((yards % 1760) / 22) / 100)).toString();
      measure_output = (Math.trunc(yards / 1760) + (((yards % 1760) / 22) / 100));
      measure_output = measure_output.toString().split('.')[1] == undefined ? measure_output.toFixed(2) : measure_output.toString();
      measure_output = measure_output.split('.')[0].padStart(3, '0') + '.' + measure_output.split('.')[1].padStart(2, '0').substring(0, 2);
      if (actualValue.length > 6) actualValue = actualValue.split('.')[0].padStart(3, '0') + '.' + actualValue.split('.')[1].padStart(2, '0').substring(0, 2);

    } else if (output_unit === 'Yards') {
      actualValue = yards;
      measure_output = Math.round(yards);
    }

    if (negative_sign) measure_output = `-${measure_output}`;
    return { display: measure_output, value: actualValue };
  }

  getMultiplier(value): any {
    return (this.isNullOrUndefined(value)) ? '1' + ('0').repeat(value.toString().length) : '1';
  }

  getMileageDisplayValue(input_measure, output_unit = 'Miles.Yards') {
    let mileage = this.measure_converter_new(input_measure, 'Yards', output_unit);
    return mileage.display;
  }

  getMaxLengthByUnit(unit: string) {
    let length = 0;
    switch (unit) {
      case 'Miles.Yards':
        length = 8;
        break;
      case 'Miles.Chains':
        length = 6;
        break;
      case 'Kilometers.Metres':
        length = 7;
        break;
    }
    return length;
  }

  validationByUnit(value: string, unit: string, type: string = null) {
    let isValid = false;
    let validationMsg = '';

    let values = value.split('.');
    if (values.length === 2) {
      switch (unit) {
        case 'Miles.Yards':
          isValid = (Number(values[1]) > 1759);
          validationMsg = type == null ? 'For Start and End mileage, Yards must be less than 1760' : 'Value should be less than 1760';
          break;
        case 'Miles.Chains':
          isValid = (Number(values[1]) > 79);
          validationMsg = type == null ? 'For Start and End mileage, Chains must be less than 80' : 'Value should be less than 80';
          break;
        case 'Kilometers.Metres':
          isValid = (Number(values[1]) > 999);
          validationMsg = type == null ? 'For Start and End mileage, Metres must be less than 1000' : 'Value should be less than 1000';
          break;
      }
    }
    return { isValid: isValid, validationMsg: validationMsg };
  }

  getMileageNumberValue(value: string) {
    let values = this.mileageToNumber(value);
    return (values.intPart + '.' + values.decimalPart);
  }

  compareMileageRange(value, startValue, endValue) {
    let values = this.mileageToNumber(value);
    let startValues = this.mileageToNumber(startValue);
    let endValues = this.mileageToNumber(endValue);
    return (values.intPart >= startValues.intPart && values.intPart <= endValues.intPart &&
      values.decimalPart >= startValues.decimalPart && values.decimalPart <= endValues.decimalPart);
  }

  private mileageToNumber(value) {
    let values = value.toString().split('.');
    let intPart = 0, decimalPart = 0;

    if (values.length === 2) { intPart = Number(values[0]); decimalPart = Number(values[1]); }
    else { intPart = Number(values[0]) }
    return { intPart: intPart, decimalPart: decimalPart }
  }

  /**
   * Method to check footer is visible on available window size
   * @returns 
   */
  isFooterVisible() {
    let visible;
    let footerContainer = document.getElementById('footerContainer');
    if (footerContainer) {
      let position = footerContainer.getBoundingClientRect();
      visible = (position.top < window.innerHeight && position.bottom >= 0);
    } else { visible = false; }
    return visible;
  }

}

export function threadSleep(value: number) {
  return new Promise(res => setTimeout(res, value));
}

export function firstLetterCapitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function isNullOrUndefined(formcontrol: AbstractControl): boolean {
  return formcontrol.value !== undefined && formcontrol.value !== null && formcontrol.value !== '';
}

export function getFormControlKeyValue(formcontrol: AbstractControl, key: string, controlVal: boolean = false) {
  return controlVal
    ? formcontrol.value?.[key] ? formcontrol.value[key] : formcontrol.value
    : formcontrol.value?.[key] ? formcontrol.value[key] : null;
}

export function getFilterModel(model: any[], key: string, value: string): any[] {
  if (key === 'elrRef') {
    let tempModel = model.sort((a, b) => a[key].localeCompare(b[key]));
    model = tempModel;
  }
  return model?.filter(function (e) { return e[key] && e[key].toString().toLowerCase().includes(value); });
}

export function getFindModel(model: any[], key: string, value: any) {
  return model.find(function (e) { return e[key] === value });
}

export function getModelToDropdown(model: any, mId: any, key: string = 'masterId') {
  return key === 'masterId'
    ? model?.find((x: any) => x.masterId === Number(mId))?.masterId
    : model?.find((x: any) => x.masterId === Number(mId))?.name.trim().toLowerCase();
}

export function getModelToAutocomplete(model: any, mId: any, mName: string, key: string = 'masterId') {
  let modelObj = model?.find(x => x.masterId === Number(mId));
  return modelObj === undefined ? { masterId: mId, name: mName } : modelObj;
}

export function groupByArrayObjects(list: any, key: string) {
  return list.reduce((hash, obj) => {
    if (obj[key] === undefined) return hash;
    return Object.assign(hash, { [obj[key]]: (hash[obj[key]] || []).concat(obj) })
  }, {});
}

export function getUnique(arr: any, propertyName: string) {
  return arr
    .sort((a, b) => a.assignmentId - b.assignmentId)
    .filter((e, i) => arr.findIndex(a => a[propertyName] === e[propertyName]) === i);
}

export function getSortedModelNumberValues(model: any[], key: string = 'name', direction: string = 'none') {
  return model?.sort((a, b) => a?.[key].localeCompare(b?.[key], undefined, { 'numeric': true }));
}

export function getSortedModelValues(model: any[], key: string = 'name', direction: string = 'none') {
  return model?.sort((a, b) => (a[key] ?? '').localeCompare(b[key] ?? ''));
}

export function JSonTryParse(value: string) {
  try {
    return JSON.parse(value);

  } catch (e) {
    return value === 'undefined' ? void 0 : value;
  }
}

export function deepCopy<T>(object) {
  if (object) return JSON.parse(JSON.stringify(object)) as T;
  else return null;
}
